// config/accessibility.js
// הגדרות נגישות — נשמרות ב-localStorage key: 'madad_accessibility'
// TODO: migrate to Backend API when available

export const ACCESSIBILITY_STORAGE_KEY = 'madad_accessibility';

// =============================================================================
// ברירות מחדל
// =============================================================================
export const defaultAccessibility = {
  fontSize: 'normal',     // 'normal' | 'large' | 'extraLarge'
  highContrast: false,
  highlightLinks: false,
  stopAnimations: false,
};

// =============================================================================
// רמות פונט
// =============================================================================
export const fontSizeLevels = {
  normal: {
    label: 'רגיל',
    scale: 1,
    htmlFontSize: 16,
  },
  large: {
    label: 'גדול',
    scale: 1.15,
    htmlFontSize: 18,
  },
  extraLarge: {
    label: 'גדול מאוד',
    scale: 1.3,
    htmlFontSize: 21,
  },
};

// =============================================================================
// CSS overrides לנגישות — מיושם על <body>
// =============================================================================
export function getAccessibilityCSS(settings) {
  const styles = {};

  // גודל פונט
  const level = fontSizeLevels[settings.fontSize] || fontSizeLevels.normal;
  styles.fontSize = `${level.htmlFontSize}px`;

  return styles;
}

// =============================================================================
// CSS classes לנגישות — מיושם על <html>
// =============================================================================
export function getAccessibilityClasses(settings) {
  const classes = [];
  if (settings.highContrast) classes.push('a11y-high-contrast');
  if (settings.highlightLinks) classes.push('a11y-highlight-links');
  if (settings.stopAnimations) classes.push('a11y-stop-animations');
  return classes;
}

// =============================================================================
// Global CSS שמיושם כשהנגישות פעילה
// =============================================================================
export const accessibilityGlobalCSS = `
  /* CSS variable לצבע focus — מעודכן דינמית מ-ThemeContext */
  :root {
    --madad-focus-color: #1565c0;
  }

  /* ניגודיות גבוהה */
  html.a11y-high-contrast {
    filter: contrast(1.35);
  }
  html.a11y-high-contrast img,
  html.a11y-high-contrast video {
    filter: contrast(0.75);
  }

  /* הדגשת קישורים */
  html.a11y-highlight-links a,
  html.a11y-highlight-links button,
  html.a11y-highlight-links [role="button"],
  html.a11y-highlight-links [role="link"] {
    outline: 2px solid var(--madad-focus-color) !important;
    outline-offset: 2px;
    text-decoration: underline !important;
  }

  /* עצירת אנימציות */
  html.a11y-stop-animations *,
  html.a11y-stop-animations *::before,
  html.a11y-stop-animations *::after {
    animation-duration: 0s !important;
    animation-delay: 0s !important;
    transition-duration: 0s !important;
    transition-delay: 0s !important;
  }

  /* Focus visible מעוצב — תמיד פעיל, צבע דינמי לפי theme */
  *:focus-visible {
    outline: 3px solid var(--madad-focus-color);
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

// =============================================================================
// שמירה וטעינה מ-localStorage
// =============================================================================
export function loadAccessibility() {
  try {
    const stored = localStorage.getItem(ACCESSIBILITY_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return { ...defaultAccessibility, ...parsed };
    }
  } catch (e) {
    // localStorage לא זמין או JSON לא תקין — שימוש בברירת מחדל
  }
  return { ...defaultAccessibility };
}

export function saveAccessibility(settings) {
  try {
    localStorage.setItem(ACCESSIBILITY_STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    // localStorage לא זמין — ההגדרות יאבדו בסגירת הדפדפן
  }
}

// =============================================================================
// החלת הגדרות נגישות על ה-DOM
// =============================================================================
export function applyAccessibilityToDOM(settings) {
  const html = document.documentElement;
  const body = document.body;

  // גודל פונט
  const level = fontSizeLevels[settings.fontSize] || fontSizeLevels.normal;
  body.style.fontSize = `${level.htmlFontSize}px`;

  // CSS classes
  const allClasses = ['a11y-high-contrast', 'a11y-highlight-links', 'a11y-stop-animations'];
  const activeClasses = getAccessibilityClasses(settings);

  allClasses.forEach((cls) => {
    if (activeClasses.includes(cls)) {
      html.classList.add(cls);
    } else {
      html.classList.remove(cls);
    }
  });
}

// =============================================================================
// עדכון צבע focus לפי theme — נקרא מ-ThemeContext בכל החלפת theme
// =============================================================================
export function updateFocusColor(primaryColor) {
  document.documentElement.style.setProperty('--madad-focus-color', primaryColor);
}
